import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RevisionPageComponent } from "./revision-page/revision-page.component";
import { Routes, RouterModule } from "@angular/router";
import { RevisionGridComponent } from "./revision-grid/revision-grid.component";

import { IconsModule } from "@va/core-library/icons";
import { SharedModule } from "../shared/shared.module";
import { FormsModule } from "@angular/forms";
import { ChartPlotterModule } from "../chart-plotter/chart-plotter.module";
import { RightPanelModule } from "../right-panel/right-panel.module";

// ant modules
import { NzTableModule } from "ng-zorro-antd/table";
import { NzLayoutModule } from "ng-zorro-antd/layout";
import { NzSwitchModule } from "ng-zorro-antd/switch";
import { NzSelectModule } from "ng-zorro-antd/select";
import { NzModalModule } from "ng-zorro-antd/modal";
import { NzInputModule } from "ng-zorro-antd/input";
import { NzPopoverModule } from "ng-zorro-antd/popover";
import { NzDatePickerModule } from "ng-zorro-antd/date-picker";
import { NzIconModule } from "ng-zorro-antd/icon";

const revisionsRoutes: Routes = [
  {
    path: "",
    pathMatch: "full",
    component: RevisionPageComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(revisionsRoutes)],
  exports: [RouterModule],
  declarations: [],
})
export class RevisionRoutingModule {}

@NgModule({
  declarations: [RevisionPageComponent, RevisionGridComponent],
  imports: [
    CommonModule,
    RevisionRoutingModule,
    IconsModule,
    SharedModule,
    FormsModule,
    ChartPlotterModule,
    RightPanelModule,
    NzTableModule,
    NzLayoutModule,
    NzSwitchModule,
    NzModalModule,
    NzInputModule,
    NzSelectModule,
    NzPopoverModule,
    NzDatePickerModule,
    NzIconModule,
  ],
})
export class RevisionPageModule {}
